import './App.css';
import Landing from './Landing';
import Footer from './Footer';

function App() {

  return (
    <div>
      <div className="App-header">
        <Landing></Landing>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default App;
